const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/marketing_emails/marketing_email_preference.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const marketingEmailPreferenceSearchSchema = z.object({
  email: z.string().optional().catch(undefined),
  token: z.string().optional().catch(undefined)
});
export const Route = createFileRoute("/marketing_emails/marketing_email_preference")({
  validateSearch: marketingEmailPreferenceSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});